/* eslint-disable react/prop-types */
import React from 'react';
import { Flex } from 'rebass';
import Footer3 from '../containers/Genesis/Footer/Footer3'
import AuthenticatedMenuBar from '../containers/Genesis/Menu/AuthenticatedMenuBar';
import menuPropsUS from '../containers/Genesis/Menu/menuPropsUS';
import menuPropsCN from '../containers/Genesis/Menu/menuPropsCN';
import footerPropsUS from '../containers/Genesis/Footer/footerPropsUS';
import footerPropsCN from '../containers/Genesis/Footer/footerPropsCN';
import url from '../utils/url';

export default function HeaderFooterLayout({isMobileLayout = false, children }) {
  const region = url.getRegion();
  const isCNRegion = region === 'CN';
  const footerProps = isCNRegion ? footerPropsCN : footerPropsUS;
  const menuProps = isCNRegion ? menuPropsCN : menuPropsUS;
  const MENU_PROPS = window?.MENU_PROPS || menuProps;
  const FOOTER_PROPS = window?.FOOTER_PROPS || footerProps;

  return (
    <Flex
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <AuthenticatedMenuBar {...MENU_PROPS} />
      <main style={{ flex: '1', minHeight: isMobileLayout ? 'calc(80vh - 88px)' : 'calc(100vh - 88px)' }}>{children}</main>
      <Footer3 {...FOOTER_PROPS} />
    </Flex>
  );
}
